import { theme } from './../../global-styles';
import styled from 'styled-components';

interface HeaderWrapperProps {
  bgColor?: string;
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  background-color: ${theme.colours.white};
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767.5px) {
    padding: 0 10px;
  }
  .small-screen {
    display: none;
    @media (max-width: 767.5px) {
      display: block;
    }
  }

  /* .select-action{
    display: block;
    @media (max-width: 768px){
      display: none;
    }
  } */

    .mantine-Select-wrapper{
      input {
        &:lang(en) {
          padding-left: unset;
        }
        &:lang(ar) {
          padding-right: 5px;
          padding-left: 1.85rem;
        }
      }
    }
  .mantine-Input-icon.mantine-Select-icon {
    &:lang(en) {
      left: unset;
      right: 0;
    }
    &:lang(ar) {
      left: 0;
      right: unset;
    }
  }

  .HeaderSection {
    position: relative;
    @media (min-width: 983px) {
      width: 983px;
    }
    @media (max-width: 983px) {
      width: 100%;
    }
    .select-action {
      input {
        border: none;
        padding-right: 5px;
        padding-bottom: 7px;
        font-size: 14px;
        font-family: ${theme.fonts.Regular};
        font-weight: 400;
        color: #000000;
      }
      .mantine-Input-rightSection {
        display: none;
      }
    }
    .buttons_wrapper {
      height: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;

      /* Arabic (RTL) - position on the left */
      &:lang(ar) {
        left: 20px;
      }

      /* English (LTR) - position on the right */
      &:lang(en) {
        right: 20px;
      }

      @media (max-width: 767px) {
        &:lang(ar) {
          left: 10px;
        }

        &:lang(en) {
          right: 10px;
        }
      }

      .select-action {
        @media (max-width: 767.5px) {
          display: none;
        }
      }
      button {
        height: 30px;
        background-color: white;
        color: #000000;
        border-radius: 20px !important;
        font-family: ${theme.fonts.Medium};
        font-size: 14px;
        font-weight: 400;
        border: 1px solid #000000;
        span {
          font-family: ${theme.fonts.Regular};
          font-size: 14px;
          font-weight: 400;
        }
        svg {
          &:lang(ar) {
            margin-right: 5px;
          }
          &:lang(en) {
            margin-left: 5px;
          }
        }
        @media (max-width: 767px) {
          border: none;
        }
      }
    }
  }
  .containerLogo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    z-index: 10;

    @media (max-width: 767px) {
      height: 45px;
    }

    img {
      max-width: 200px;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
    }
  }
  .containerLang {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    > div {
      background-color: ${theme.colours.AntiFlashWhite};
      padding: 10px;
      border-radius: 12px;
      cursor: pointer;
      color: ${theme.colours.NewCar};
      font-family: ${theme.fonts.Medium};
    }
  }
`;
